<template>
  <div class="modal-view">
    <div class="message">
        {{ this.message }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'MessageModal',
  props: ['message'],
  data () {
    return {
        data: {}
    }
  },
  methods: {
    selectOption(opt) {
      this.$router.push(opt.id)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
$gray: #343a40;

.modal-view {
  z-index: 99999;
  width: 400px;
  height: 300px;
  position: absolute;
  border-radius: 20px;
  border: 5px $gray solid;
  background-color: $gray;
  color: #fff;
  margin: auto;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  box-shadow: 5px 5px rgba(0, 0, 0, 0.25);

  display: flex;
  align-items: center;

  .message {
    font-size: 3.5rem;
    text-align: center;
  }
}

@media screen and (max-width: 540px) {
  .modal-view {
    width: 300px;
    height: 200px;
    .message {
      font-size: 3rem;
    }
  }
}

@media screen and (max-width: 374px) {
  .modal-view {
    width: 250px;
    height: 150px;
    .message {
      font-size: 2.5rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modals/MessageModal.vue